import cn from "classnames";
import { type CSSProperties, type FC, type ReactNode, useState } from "react";
import "./InboxAvatar.css";

const VIDEO_PATH = /\.(mp4|m4v|mov|webm|mkv|m3u8)$/i;

function isUsableImageUrl(url: string | null | undefined): url is string {
	const trimmed = url?.trim();
	if (!trimmed) return false;
	try {
		return !VIDEO_PATH.test(new URL(trimmed).pathname);
	} catch {
		return !VIDEO_PATH.test(trimmed.split("?")[0] ?? trimmed);
	}
}

interface InboxAvatarProps {
	url?: string | null;
	label: string;
	variant?: "person" | "post";
	size?: number;
	badge?: ReactNode;
}

export const InboxAvatar: FC<InboxAvatarProps> = ({
	url,
	label,
	variant = "person",
	size = 44,
	badge,
}) => {
	const src = isUsableImageUrl(url) ? url.trim() : null;
	const [failedSrc, setFailedSrc] = useState<string | null>(null);
	const showImage = !!src && failedSrc !== src;
	const initial = (label || "?").trim().charAt(0).toUpperCase() || "?";

	return (
		<div
			className={cn("inbox-avatar", `inbox-avatar--${variant}`)}
			style={{ "--inbox-avatar-size": `${size}px` } as CSSProperties}
		>
			<div className="inbox-avatar-media">
				{showImage ? (
					<img
						src={src}
						alt=""
						referrerPolicy="no-referrer"
						onError={() => setFailedSrc(src)}
					/>
				) : (
					<div className="inbox-avatar-placeholder">{initial}</div>
				)}
			</div>
			{badge ? <div className="inbox-avatar-badge">{badge}</div> : null}
		</div>
	);
};
